/**
 * Custom JS
 */

import { linkCard } from "./cards.js";
import { accordion } from "./accordion.js";
import { callBackTempsFort } from "./tiny-slider.js";

linkCard();
accordion();
callBackTempsFort();


document.addEventListener("DOMContentLoaded", function() {
    let screenWidth = document.querySelector('body').getBoundingClientRect().width;
    topNavigationFixed(screenWidth);

    onresize = (event) => {
        let screenWidth = document.querySelector('body').getBoundingClientRect().width;
        topNavigationFixed(screenWidth);
    };

    window.onscroll = function() {
        let screenWidth = document.querySelector('body').getBoundingClientRect().width;
        topNavigationFixed(screenWidth);
    };

    function topNavigationFixed(screenWidth) {
        if(screenWidth <= 1023) {
            let pageHeaderHeight = document.querySelector('#page-header').offsetHeight;
            document.querySelector('#main-content').style.marginTop = pageHeaderHeight+'px';
        } else {
            document.querySelector('#main-content').style.marginTop = '0px';
        }
    }
  });

$(document).on('click', '.heading-accordion', function() {
    const ariaExpanded = $(this).attr('aria-expanded') === 'true' || false;

    let text = $(this).attr('data-text');
    console.log(text);
    $(this).attr('data-text', $(this).text());
    $(this).text(text);

    $(this).attr('aria-expanded', !ariaExpanded);
    $(this).siblings('.accordion-panel').toggleClass('open');
    $(this).siblings('.accordion-panel').find('a:first-child').focus();
});